export const APPOINT_CAN_REQUEST = "APPOINT_CAN_REQUEST";
export const APPOINT_CAN_SUCCESS = "APPOINT_CAN_SUCCESS";
export const APPOINT_CAN_FAIL = "APPOINT_CAN_FAIL";
